// extracted by mini-css-extract-plugin
module.exports = {"main":"lay_main__2i3vJ"};